module.exports = __webpack_public_path__ + "static/img/line-recharge.4ba6d90f.png";